import { render, staticRenderFns } from "./AdminUserRegister.vue?vue&type=template&id=38a55d34&"
import script from "./AdminUserRegister.vue?vue&type=script&lang=js&"
export * from "./AdminUserRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports